import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatMenu } from '@angular/material/menu';

@Component({
  selector: 'common-mat-menu-template',
  templateUrl: './mat-menu-template.component.html',
  styleUrls: ['./mat-menu-template.component.scss'],
})
export class MatMenuTemplateComponent implements OnInit {

  @Input() title!: string;
  @Input() placeholder!: string;
  @Input() labelButtonCancel!: string;
  @Input() labelButtonSave!: string;
  @Input() typeAction: 'input' | 'select' = 'input';
  @Input() floatLabelType: 'always' | 'never' = 'never';
  @Input() options: any[] = [];
  @Input() valueFn: (option: any) => any;
  @Input() displayFn: (option: any) => string;
  @ViewChild('popover') public popover: MatMenu;

  @Output() cancel: EventEmitter<boolean> = new EventEmitter();
  @Output() save: EventEmitter<string> = new EventEmitter();

  searchControl = new FormControl('');

  constructor() { }

  ngOnInit(): void {
  }


  onEventSearch(event: string) {
    this.searchControl.setValue(event);
  }

  onEventSelect(event: string) {
    this.searchControl.setValue(event);
  }

  onEventCancel(event: boolean) {
    this.cancel.emit(event);
    this.popover.closed.emit();
  }

  onEventSave(event: string) {
    this.save.emit(this.searchControl.value);
    this.popover.closed.emit();
  }
}
